import React, { lazy, Suspense, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import classNames from 'classnames';
import { Button } from '@fiverr-private/fit';
import { MP_CLICKED_CUSTOM_ORDER_REQUEST } from '../../../utils/mixPanelEvents/index';
import { BQ_CLICKED_CUSTOM_ORDER } from '../../../utils/bigQueryEvents/index';
import sendGraphiteEvent from '../../../utils/sendGraphiteEvent';
import { CUSTOM_ORDER_SUBMIT } from '../../../utils/sendGraphiteEvent/events';
import { CUSTOM_ORDER_SOURCE } from '../../../utils/customOrder/constants';
import { getFormData } from '../api';
import { isLoggedInUser } from '../../../utils/isLoggedInUser';
import { FIT_MODAL_CLASS, JS_JOIN_HOOK } from '../../../utils/constants';

import './style.scss';

const CustomOrderModal = lazy(() =>
    import(/* webpackChunkName: 'CustomOrderModal' */'@fiverr-private/custom_order/src/entries/CustomOrderModalEntry')
);

const CustomOrder = (props, { pathfinderWrapper, requestContext, biEvents, currencyConverter, general }) => {
    const [formData, setFormData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [openModal, setOpenModal] = useState(() => _.noop);

    const uploadOptions = {
        objectName: 'message',
        getPolicyUrl: pathfinderWrapper.pathfinder('messages_attachments_policy'),
        createPendingAttachmentIdUrl: pathfinderWrapper.pathfinder('messages_create_pending_attachment')
    };

    const { params, current_user: currentUser } = requestContext;
    const isGuest = !isLoggedInUser(currentUser);
    const biEnrichmentData = biEvents.getEnrichmentData();

    const onClickReport = () => {
        biEvents.sendMixPanelEvent({ eventName: MP_CLICKED_CUSTOM_ORDER_REQUEST });
        biEvents.sendBigQueryEvent({ eventName: BQ_CLICKED_CUSTOM_ORDER });
    };

    const onClick = () => {

        if (isGuest) {return;}

        onClickReport();

        if (isValidFormData()) {
            openModal();
            return;
        }

        setIsLoading(true);

        getFormData({ requestContext, pathfinderWrapper })
            .then(({ data }) => {
                setIsLoading(false);
                setFormData(data);
            })
            .catch(() => {
                setIsLoading(false);
            });
    };

    const setOpenModalHandle = (open) => {
        setOpenModal(() => open);
    };

    const isValidFormData = () => {
        const { seller, categoriesData } = formData;

        return !!(seller && categoriesData);
    };

    const { currency } = currencyConverter;
    const { slug } = params;
    const { seller, categoriesData } = formData;
    const submitPath = pathfinderWrapper.pathfinder('create_custom_order_request');

    const btnColor = general.isPro ? Button.COLORS.BLACK : Button.COLORS.GREY;
    const triggerButtonClass = classNames('btn-get-quote', {
        [JS_JOIN_HOOK]: isGuest
    });

    return (
        <div className="custom-order">
            <h6><I18n k={'gig_page_perseus.custom_order.title'}/></h6>
            <Button onClick={onClick}
                className={triggerButtonClass}
                fill={Button.FILLS.GHOST}
                color={btnColor}
                size={Button.SIZES.SMALL}
                disabled={isLoading}>
                <I18n k={'gig_page_perseus.custom_order.get_a_quote'}/>
            </Button>
            {isValidFormData() &&
            <Suspense fallback={<div/>}>
                <CustomOrderModal name={FIT_MODAL_CLASS}
                    gigSlug={slug}
                    source={CUSTOM_ORDER_SOURCE}
                    autoOpen={true}
                    trigger={setOpenModalHandle}
                    currency={currency}
                    seller={seller}
                    categoriesData={categoriesData}
                    submitPath={submitPath}
                    uploadOptions={uploadOptions}
                    biEnrichmentData={biEnrichmentData}
                    onSubmitSuccess={() => {
                        sendGraphiteEvent(CUSTOM_ORDER_SUBMIT);
                    }}/>
            </Suspense>
            }
        </div>
    );
};

CustomOrder.contextTypes = {
    biEvents: PropTypes.object,
    requestContext: PropTypes.object,
    pathfinderWrapper: PropTypes.object,
    currencyConverter: PropTypes.object,
    general: PropTypes.object
};

export default CustomOrder;
